module.exports = __webpack_public_path__ + "static/media/loader.235b9b3e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loader.gif
// module id = 132
// module chunks = 0